<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Compartilhar Documentos"
  description="Gerencie o compartilhamento de documentos da sua empresa">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">

  <!-- Seção: Meus Compartilhamentos -->
  @if(profileProviderPJ && profileProviderPJ.cnpj){
  <section class="mb-xl">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Meus Compartilhamentos</h3>
      </div>
      <div class="card-body">
        <app-document-sharing #sharedComponent [owner]="profileProviderPJ.cnpj"
          [add]="addToShared"></app-document-sharing>
      </div>
    </div>
  </section>
  }

  <!-- Seção: Documentos Compartilhados Comigo -->
  @if(profileProviderPJ && profileProviderPJ.cnpj && hasFeatureAccess(profileProviderPJ.cnpj,
  Feature.SHARED_DOCUMENTS_BY)){
  <section class="mb-xl">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Documentos Compartilhados Comigo</h3>
      </div>
      <div class="card-body">
        <app-document-sharing #accessComponent [granted]="profileProviderPJ.cnpj"
          [add]="addToAccess"></app-document-sharing>
      </div>
    </div>
  </section>
  }

  <!-- Seção: Novo Compartilhamento -->
  <section class="mb-xl">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Novo Compartilhamento</h3>
      </div>
      <div class="card-body">




        <!-- Aviso LGPD -->
        <div class="alert alert-warning mb-lg">
          <span>⚠</span>
          <div>
            <strong>Aviso de Privacidade (LGPD):</strong>
            <p>Ao compartilhar ou solicitar acesso a documentos, você está de acordo com as regras de proteção de dados
              e concorda que as partes envolvidas poderão acessar os documentos e arquivos compartilhados.</p>
          </div>
        </div>

        <!-- Seletor de Tipo -->
        <div class="share-type-selector mb-lg">
          <mat-radio-group [formControl]="shareTypeControl">
            <mat-radio-button value="share" class="radio-option">
              <div class="radio-content">
                <mat-icon>share</mat-icon>
                <div>
                  <strong>Compartilhar meus documentos</strong>
                  <p>Permitir que outra empresa acesse seus documentos</p>
                </div>
              </div>
            </mat-radio-button>
            @if(profileProviderPJ && profileProviderPJ.cnpj && hasFeatureAccess(profileProviderPJ.cnpj,
            Feature.SHARED_DOCUMENTS_BY)){
            <mat-radio-button value="request" class="radio-option">
              <div class="radio-content">
                <mat-icon>get_app</mat-icon>
                <div>
                  <strong>Solicitar acesso a documentos</strong>
                  <p>Pedir para acessar documentos de profissionais ou empresas</p>
                </div>
              </div>
            </mat-radio-button>
            }
          </mat-radio-group>

          <!-- Informações -->
          <div class="alert alert-info mb-lg">

            <div>
              @if(shareTypeControl.value === 'share'){
              <p><strong>Como funciona o compartilhamento:</strong></p>
              <p>1. Informe o CNPJ da empresa cadastrada</p>
              <p>2. A empresa receberá acesso aos seus documentos compartilháveis</p>
              <p>3. Você poderá revogar o acesso a qualquer momento</p>
              } @else {
              <p><strong>Como solicitar acesso:</strong></p>
              <p>1. Informe o CPF ou CNPJ do profissional/empresa</p>
              <p>2. O profissional receberá uma notificação da solicitação</p>
              <p>3. Após aprovação, você terá acesso aos documentos compartilháveis</p>
              }
            </div>

            <!-- Formulário de Busca -->
            <div class="card card-white mb-lg">
              @if(shareTypeControl.value === 'share'){
              <label class="text-sm font-semibold">CNPJ da Empresa</label>
              } @else {
              <label class="text-sm font-semibold">CPF ou CNPJ</label>
              }
              <div class="input-group">
                @if(shareTypeControl.value === 'share'){
                <input [formControl]="cpfcnpjControl" [showMaskTyped]="true" mask="00.000.000/0000-00"
                  placeholder="00.000.000/0000-00" class="input" />
                } @else {
                <input [formControl]="cpfcnpjControl" [showMaskTyped]="true" mask="000.000.000-00 || 00.000.000/0000-00"
                  placeholder="Digite o CPF ou CNPJ" class="input" />
                }
                <button class="btn btn-primary" [disabled]="!isCpfOrCnpjInvalid()" (click)="searchCpfOrCnpj()">
                  Pesquisar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Resultado da Busca: Pessoa Física -->
        @if(userRefFound){
        <div class="file-container">
          <div class="file-card">
            <div class="file-icon">
              <mat-icon>person</mat-icon>
            </div>
            <div class="file-info">
              <h4 class="file-title">{{ userRefFound.firstName }} {{ userRefFound.lastName }}</h4>
              <p class="file-name">CPF: {{ userRefFound.cpf }}</p>
              <p class="file-name">Email: {{ userRefFound.email }}</p>
              <div class="file-meta">
                <span class="badge badge-success">Profissional Encontrado</span>
              </div>
            </div>
            <div>
              <button mat-raised-button color="primary" (click)="shareDocuments()">
                <mat-icon>{{ shareTypeControl.value === 'share' ? 'share' : 'send' }}</mat-icon>
                {{ shareTypeControl.value === 'share' ? 'Compartilhar' : 'Solicitar' }}
              </button>
            </div>
          </div>
        </div>
        }

        <!-- Resultado da Busca: Pessoa Jurídica -->
        @if(profileProviderPJFound){
        <div class="file-container">
          <div class="file-card">
            <div class="file-icon">
              <mat-icon>business_center</mat-icon>
            </div>
            <div class="file-info">
              <h4 class="file-title">{{ profileProviderPJFound.companyName }}</h4>
              <p class="file-name">CNPJ: {{ profileProviderPJFound.cnpj }}</p>
              <div class="file-meta">
                <span class="badge badge-success">Empresa Encontrada</span>
              </div>
            </div>
            <div>
              <button mat-raised-button color="primary" (click)="shareDocuments()">
                <mat-icon>{{ shareTypeControl.value === 'share' ? 'share' : 'send' }}</mat-icon>
                {{ shareTypeControl.value === 'share' ? 'Compartilhar' : 'Solicitar' }}
              </button>
            </div>
          </div>
        </div>
        }

      </div>
    </div>
  </section>

</div>
}